import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { sessionConstants } from "@constants/appConstants";

import { getLocalStorageItem } from "@utils/sessionUtils";

import english from "./locales/en/translation.json";
import spanish from "./locales/es/translation.json";
import chinese from "./locales/zh/translation.json";

// Vite glob import: eagerly loads all locale JSON files at build time
const localeModules = import.meta.glob("./locales/**/*.json", { eager: true });

const loadTranslationFile = async language => {
  const translations = {};
  const prefix = `./locales/${language}/`;

  for (const [path, mod] of Object.entries(localeModules)) {
    if (path.startsWith(prefix)) {
      Object.assign(translations, mod.default ?? mod);
    }
  }

  // Fallback to English translations if no translations were found
  if (Object.keys(translations).length === 0) {
    const enPrefix = "./locales/en/";
    for (const [path, mod] of Object.entries(localeModules)) {
      if (path.startsWith(enPrefix)) {
        Object.assign(translations, mod.default ?? mod);
      }
    }
  }

  return translations;
};

export const initializeLocal = async (userLanguage = "en") => {
  userLanguage = getLocalStorageItem(sessionConstants.appLanguage);
  if (!userLanguage || userLanguage === "undefined") {
    userLanguage = "en";
  }
  const translationFile = await loadTranslationFile(userLanguage);

  const resources = {
    en: { translation: english },
    es: { translation: spanish },
    zh: { translation: chinese },
    [userLanguage]: { translation: translationFile },
  };

  // Dynamically load the user language if it's English
  if (userLanguage === "en" && Object.keys(translationFile).length > 0) {
    resources.en = { translation: translationFile };
  }

  i18n.use(initReactI18next).init({
    resources,
    lng: userLanguage,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });
};

export const tWithEnglishFallback = (t, key, options) => {
  const translation = t(key, { ...options, defaultValue: undefined });
  if (translation !== key) return translation;
  const english = t(key, { ...options, lng: "en", defaultValue: undefined });
  if (english !== key) return english;
  return null;
};
